import { all } from "redux-saga/effects";
import authSaga from "./authSaga";
import passengerSaga from "./passegerSaga";
import destinationSaga from "./destinationSaga";
import routeSaga from "./routeSaga";
import routeGroupSaga from "./routeGroupSaga";
import connectionSaga from "./connectionSaga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    passengerSaga(),
    destinationSaga(),
    routeSaga(),
    connectionSaga(),
    routeGroupSaga(),
  ]);
}
